module.exports = __webpack_public_path__ + "img/Tripplanner copy.959ac6ea.svg";